import 'apps/pathways/styles/components/interest-survey.scss';
import React from 'react';
import { Prompt } from 'library/util/core-router';
import Interests from 'apps/pathways/test_data/interests.json';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';

const StrongDislike = ({ ...props }) => (
  <svg width="76px" height="72px" viewBox="0 0 76 72" version="1.1" xmlns="http://www.w3.org/2000/svg" { ...props }>
    <g fillRule="nonzero" fill="currentColor">
      <path d="M0,60 L0,12 C0,4 6,0 16,0 L60,0 C70,0 76,4 76,12 L76,60 C76,68 70,72 60,72 L16,72 C6,72 0,68 0,60 Z M11,52.5 L13.5,55 C16.8,52.4 20.3,50.5 23.8,49.2 C23.2,52.5 22.4,56.9 22.4,57.9 C22.4,62.9 28.3,65.7 33,65.7 C37.5,65.7 40.8,63.7 41.4,60 L43.5,47.3 C50.3,48 56.6,50.3 62.5,55 L65,52.5 C58,44 48,40 38,40 C28,40 18,44 11,52.5 Z M12,30 L15,33 L22.5,26 L30,33 L33,30 L26,22.5 L33,15 L30,12 L22.5,19 L15,12 L12,15 L19,22.5 L12,30 Z M29.9,59.7 L32.5,45 L34.8,45.4 L32.3,60.1 L29.9,59.7 Z M43,30 L46,33 L53.5,26 L61,33 L64,30 L57,22.5 L64,15 L61,12 L53.5,19 L46,12 L43,15 L50,22.5 L43,30 Z" id="Shape"></path>
    </g>
  </svg>
);
const Dislike = ({ ...props }) => (
  <svg width="76px" height="72px" viewBox="0 0 76 72" version="1.1" xmlns="http://www.w3.org/2000/svg" { ...props }>
    <g fillRule="nonzero" fill="currentColor">
      <path d="M0,60 L0,12 C0,4 6,0 16,0 L60,0 C70,0 76,4 76,12 L76,60 C76,68 70,72 60,72 L16,72 C6,72 0,68 0,60 Z M12,57 L14.5,59 C21.5,52 29.5,50 38,50 C46.5,50 54.5,52 61.5,59 L64,57 C58,46 47,42 38,42 C29,42 18,46 12,57 Z M18,23 C18,28.5 21.1,33 25,33 C28.9,33 32,28.5 32,23 C32,17.5 28.9,13 25,13 C21.1,13 18,17.5 18,23 Z M44,23 C44,28.5 47.1,33 51,33 C54.9,33 58,28.5 58,23 C58,17.5 54.9,13 51,13 C47.1,13 44,17.5 44,23 Z" id="Shape"></path>
    </g>
  </svg>
);
const Unsure = ({ ...props }) => (
  <svg width="76px" height="72px" viewBox="0 0 76 72" version="1.1" xmlns="http://www.w3.org/2000/svg" { ...props }>
    <g fillRule="nonzero" fill="currentColor">
      <path d="M0,60 L0,12 C0,4 6,0 16,0 L60,0 C70,0 76,4 76,12 L76,60 C76,68 70,72 60,72 L16,72 C6,72 0,68 0,60 Z M17,23 C17,29.4 20.6,34.5 25,34.5 C29.4,34.5 33,29.4 33,23 C33,16.6 29.4,11.5 25,11.5 C20.6,11.5 17,16.6 17,23 Z M21.8,55.3 L24.2,60.8 L62.5,43.5 L60,38 L21.8,55.3 Z M44.5,23 C44.5,28.2 47.4,32.5 51,32.5 C54.6,32.5 57.5,28.2 57.5,23 C57.5,17.8 54.6,13.5 51,13.5 C47.4,13.5 44.5,17.8 44.5,23 Z" id="Shape"></path>
    </g>
  </svg>
);
const Like = ({ ...props }) => (
  <svg width="76px" height="72px" viewBox="0 0 76 72" version="1.1" xmlns="http://www.w3.org/2000/svg" { ...props }>
    <g fillRule="nonzero" fill="currentColor">
      <path d="M0,60 L0,12 C0,4 6,0 16,0 L60,0 C70,0 76,4 76,12 L76,60 C76,68 70,72 60,72 L16,72 C6,72 0,68 0,60 Z M10,42 C15,53 26,60 38,60 C50,60 61,53 66,42 L63.5,40 C56,48 49,52 38,52 C27,52 20,48 12.5,40 L10,42 Z M18,23 C18,28.5 21.1,33 25,33 C28.9,33 32,28.5 32,23 C32,17.5 28.9,13 25,13 C21.1,13 18,17.5 18,23 Z M44,23 C44,28.5 47.1,33 51,33 C54.9,33 58,28.5 58,23 C58,17.5 54.9,13 51,13 C47.1,13 44,17.5 44,23 Z" id="Shape"></path>
    </g>
  </svg>
);
const StrongLike = ({ ...props }) => (
  <svg width="76px" height="72px" viewBox="0 0 76 72" version="1.1" xmlns="http://www.w3.org/2000/svg" { ...props }>
    <g fillRule="nonzero" fill="currentColor">
      <path d="M0,60 L0,12 C0,4 6,0 16,0 L60,0 C70,0 76,4 76,12 L76,60 C76,68 70,72 60,72 L16,72 C6,72 0,68 0,60 Z M8,36 C8,45.2 12.7,53.3 20,58.4 L20,36 L8,36 L8,36 Z M11,20 L14.5,22.5 C16,19.5 19,17 23,17 C27,17 29.5,19 31.5,22.5 L35,20 C33,15.5 29,11.5 23,11.5 C17,11.5 13,15.5 11,20 Z M23,60.3 C27,62.5 31.6,63.8 36.5,64 L36.5,36 L23,36 L23,60.3 Z M39.5,64 C44.4,63.8 49,62.5 53,60.3 L53,36 L39.5,36 L39.5,64 Z M41,20 L44.5,22.5 C46,19.5 49,17 53,17 C57,17 59.5,19 61.5,22.5 L65,20 C63,15.5 59,11.5 53,11.5 C47,11.5 43,15.5 41,20 Z M56,58.4 C63.3,53.3 68,45.2 68,36 L56,36 L56,58.4 Z" id="Shape"></path>
    </g>
  </svg>
);

const InterestRating = ({ onChange, references, index, rating = null }) => (
  <div className="interest-rating">
    <span onClick={()=> onChange(index, 1)} className='interest-survey-ratings'>
      <input onClick={()=> onChange(index, 1)} ref={references(index, 0)} id={`ratings:${index}-0`} type='checkbox'/>
      <StrongDislike className={rating === 1 ? 'active' : ''} />
    </span>

    <span onClick={()=> onChange(index, 2)} className='interest-survey-ratings' >
      <input onClick={()=> onChange(index, 2)} ref={references(index, 1)} id={`ratings:${index}-1`} type='checkbox'/>
      <Dislike className={rating === 2 ? 'active' : ''} />
    </span>

    <span onClick={()=> onChange(index, 3)} className='interest-survey-ratings'>
      <input onClick={()=> onChange(index, 3)} ref={references(index, 2)} id={`ratings:${index}-2`} type='checkbox'/>
      <Unsure className={rating === 3 ? 'active' : ''} />
    </span>

    <span onClick={()=> onChange(index, 4)} className='interest-survey-ratings'>
      <input onClick={()=> onChange(index, 4)} ref={references(index, 3)} id={`ratings:${index}-3`} type='checkbox'/>
      <Like className={rating === 4 ? 'active' : ''} />
    </span>

    <span onClick={()=> onChange(index, 5)} className='interest-survey-ratings'>
      <input onClick={()=> onChange(index, 5)} ref={references(index, 4)} id={`ratings:${index}-4`} type='checkbox'/>
      <StrongLike className={rating === 5 ? 'active' : ''} />
    </span>
  </div>
);

InterestRating.propTypes = {
  onChange: PropTypes.func,
  references: PropTypes.func,
  index: PropTypes.number,
  rating: PropTypes.number,
};


class Interest extends React.PureComponent {
  validRating = () => {
    if (this.props.rating == 0 || this.props.rating == null) return 0;
    return this.props.rating.substring(this.props.index, this.props.index+1);
  }

  render() {
    const { interest, rating, index, error, references, onChange } = this.props;

    return (
      <div data-interest={index} className={['interest', error === index && rating === null ? 'errored' : null].filter(c=>c).join(' ')}>
        <div className={['interest-dot-indicator', Number(this.validRating()) < 1 ? null: 'completed'].filter(c=>c).join(' ')} />
        <InterestRating onChange={onChange} references={references} index={index} rating={Number(this.validRating())} /> <span>{ interest }</span>
      </div>
    );
  }
}

Interest.propTypes = {
  interest: PropTypes.string,
  rating: PropTypes.number,
  set: PropTypes.func,
  references: PropTypes.func,
  index: PropTypes.number,
  error: PropTypes.number,
  onChange: PropTypes.func
};

export default class InterestSurvey extends React.Component {
  state = {};

  constructor(...params) {
    super(...params);
    this.references = [];
  }

  componentDidMount() {
    window.addEventListener('keydown', this.arrowKeys);

  }

  componentWillUnmout() {
    window.removeEventListener('keydown', this.arrowKeys);
  }

  static propTypes = {
    updateInterest: PropTypes.string,
    values: PropTypes.string,
    completedInterest: PropTypes.func
  }


  onChange = (index, i) => {
    const values = [];
    let finished = false;

    if (this.props.values == null || this.props.values == '' || this.props.values == []) {
      for (let i = 0; i < 60; i++) {
        values.push(0);
      }
    } else {
      for (let i = 0; i < this.props.values.length; i++) {
        values.push(this.props.values.substring(i, i+1));
      }
    }

    values[index] = i;

    for(let i = 0; i < values; i++) {
      if (values[i] == 0) {
        finished = true;
      }
    }

    const v = values.join('');

    this.props.completedInterest(finished);
    this.props.updateInterest(v);
  }

  arrowKeys = (e) => {
    const id = document.activeElement.id;

    if(!id.startsWith('ratings:')) return null;
    const core = id.replace('ratings:', '');

    let [row, col] = core.split('-');
    row = Number(row);
    col = Number(col);

    const referenceSize = [this.references.length, this.references[0].length];

    const { key } = e;
    switch (key) {
    case 'ArrowUp': {
      if ( row > 0 ) this.getRef(row-1,col).current.focus();
      break;
    }
    case 'ArrowDown': {
      if ( row < referenceSize[0] ) this.getRef(row+1,col).current.focus();
      break;
    }
    case 'ArrowRight': {
      if (col < referenceSize[1]  -1 ) {
        this.getRef(row,col+1).current.focus();
      } else if (row < referenceSize[0]) {
        this.getRef(row+1, 0).current.focus();
      }
      break;
    }
    case 'ArrowLeft': {
      if (col > 0 ) {
        this.getRef(row,col-1).current.focus();
      } else if (row > 0) {
        this.getRef(row-1,referenceSize[1]-1).current.focus();
      }
      break;
    }
    }

  }

  getRef = (row, col) => {
    if (!resolve(this.references, `${row}/${col}`, null)) {
      this.references[row] = this.references[row]||[];
      this.references[row][col] = React.createRef();
    }
    return this.references[row][col];
  }

  render() {
    const interests = (resolve(this.props, 'interests', '')||'').split('');
    const error = null;
    const isActive = interests.indexOf(null) > -1 && !interests.every(r=>r===null);
    return (
      <div className="interest-survey">
        <Prompt when={isActive} message="Are you sure?" />
        <h3> Take the O*NET Interest Profiler </h3>
        <p>The <b>O*NET Interest Profiler</b> has 60 questions about work activities that some people do on their jobs. Read each question carefully and decide how you would feel about doing each type of work.</p>
        <p className="interest-survey-instruction-key">
          <strong>Key</strong>
          <span>
            <StrongDislike width="24" height="24" /> = Strongly Dislike
          </span>
          <span>
            <Dislike width="24" height="24" /> = Dislike
          </span>
          <span>
            <Unsure width="24" height="24" /> = Unsure
          </span>
          <span>
            <Like width="24" height="24" /> = Like
          </span>
          <span>
            <StrongLike width="24" height="24" /> = Strongly Like
          </span>
        </p>
        { Interests.map((interest, i)=>
          <Interest
            error={error}
            references={this.getRef}
            rating={resolve(this.props, 'values', 0)}
            interest={interest}
            index={i}
            key={i}
            onChange={this.onChange}
          />)
        }
      </div>
    );
  }
}
